/**
 * Bredvid-layout + format auto + höjd "anpassa till bild":
 * maxhöjd = min(naturlig bildhöjd i kolumnen, rubrik+brödtext höjd). Kräver [data-article-split-adapt-cap] på <article>.
 */
(function () {
  const MQ = window.matchMedia('(min-width: 750px)');

  function textColumnHeight(article) {
    const title = article.querySelector('.article-template__split-item--title');
    const body = article.querySelector('.article-template__split-item--body');
    if (!title || !body) return 0;
    return body.getBoundingClientRect().bottom - title.getBoundingClientRect().top;
  }

  function clearCap(mediaBox, img) {
    mediaBox.style.maxHeight = '';
    mediaBox.style.height = '';
    mediaBox.style.minHeight = '';
    mediaBox.style.overflow = '';
    if (img) {
      img.style.maxHeight = '';
      img.style.height = '';
      img.style.width = '';
      img.style.objectFit = '';
      img.style.objectPosition = '';
    }
  }

  function applyCap(article) {
    const mediaBox = article.querySelector('.article-split-adapt-cap');
    const img = mediaBox && mediaBox.querySelector('img');
    if (!mediaBox || !img) return;

    if (!MQ.matches) {
      clearCap(mediaBox, img);
      return;
    }

    const textH = textColumnHeight(article);
    if (textH <= 0) return;

    const w = img.clientWidth;
    if (w <= 0) return;

    if (!img.naturalWidth || !img.naturalHeight) {
      return;
    }

    const naturalDisplayH = (img.naturalHeight / img.naturalWidth) * w;

    if (naturalDisplayH > textH) {
      // Klippt: fast höjd + cover så underkant följer border-radius (contain lämnar “hål” med fyrkantig botten)
      mediaBox.style.height = `${textH}px`;
      mediaBox.style.maxHeight = `${textH}px`;
      mediaBox.style.overflow = 'hidden';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.maxHeight = 'none';
      img.style.objectFit = 'cover';
      img.style.objectPosition = 'top center';
    } else {
      mediaBox.style.height = '';
      mediaBox.style.maxHeight = `${Math.min(naturalDisplayH, textH)}px`;
      mediaBox.style.overflow = 'hidden';
      img.style.width = '100%';
      img.style.height = 'auto';
      img.style.maxHeight = 'none';
      img.style.objectFit = '';
      img.style.objectPosition = '';
    }
  }

  function bindArticle(article) {
    if (article.dataset.splitAdaptBound) return;
    article.dataset.splitAdaptBound = '1';

    const run = () => {
      requestAnimationFrame(() => applyCap(article));
    };

    const img = article.querySelector('.article-split-adapt-cap img');
    if (img) {
      if (img.complete) {
        run();
      } else {
        img.addEventListener('load', run, { once: true });
      }
    } else {
      run();
    }

    const ro = new ResizeObserver(run);
    const title = article.querySelector('.article-template__split-item--title');
    const body = article.querySelector('.article-template__split-item--body');
    if (title) ro.observe(title);
    if (body) ro.observe(body);
    ro.observe(article);

    const mediaBox = article.querySelector('.article-split-adapt-cap');
    if (mediaBox) ro.observe(mediaBox);

    MQ.addEventListener('change', run);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    }
  }

  function init() {
    document.querySelectorAll('article[data-article-split-adapt-cap]').forEach(bindArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
